<template id="">
  <div class="md-layout">
    <md-card class="md-layout-item md-size-60 md-medium-size-100" v-if="quizOff">
      <md-card-header class="md-card-header-icon">
        <div class="card-icon"><md-icon>school</md-icon></div>
        <h4 class="title">SafeCore Safety and Risk Management Test: Overview</h4>
      </md-card-header>
      <md-card-content class="training-content">
        <h3>Test Overview</h3>
        <p>This test is 10 questions. Please read the SafeCore Safety and Risk Management Training before completing.</p>
      </md-card-content>
      <md-card-actions>
        <md-button class="md-info" @click="startTest">Start Test</md-button>
      </md-card-actions>
    </md-card>
    <template v-else>
      <template v-for="(question, index) in questions" >
        <md-card class="md-layout-item md-size-60 md-medium-size-100" v-if="index == currentCard" :key="question.id">
            <md-card-header class="md-card-header-icon">
              <div class="card-icon"><md-icon>school</md-icon></div>
              <h4 class="title">SafeCore Safety and Risk Management Test: Question #{{question.id}}</h4>
            </md-card-header>
            <md-card-content class="question-content">
              <h3>{{question.questionText}}</h3>
              <md-radio v-model="question.answer" :value="true">Yes</md-radio>
              <md-radio v-model="question.answer" :value="false">No</md-radio>
              <p v-if="question.answer == false">Please re-read the SafeCore Safety and Risk Management Training to be able to answer Yes to this question before moving on in the test.</p>
            </md-card-content>
            <md-card-actions md-alignment="left">
              <md-button class="md-info" @click="nextQ(index)" :disabled="question.answer == false || question.answer == null" v-if="question.id !== 10">Next Question</md-button>
              <md-button class="md-info" @click="submitTest" :disabled="question.answer == false || question.answer == null" v-if="question.id == 10">Submit Test</md-button>
            </md-card-actions>
        </md-card>
      </template>
    </template>

  </div>
</template>
<script>
  import api from "@/api"
  export default {
    data(){
      return {
        quizOff: true,
        currentCard: 0,
        questions: [
          {
            id: 1,
            questionText: "Do you understand the limitations of GPR including but not limited to: Targets under targets cannot be detected, green concrete, moisture, voids, pan decking and tightly spaced mesh?",
            answer: null
          },
          {
            id: 2,
            questionText: "Do you understand that GPR cannot determine the diameter of an object?",
            answer: null
          },
          {
            id: 3,
            questionText: "Do you understand that GPR cannot distinguish between rebar, PT cable, conduits, fiber optic lines as well as any structural steel?",
            answer: null
          },
          {
            id: 4,
            questionText: "Do you understand the SafeCore Color codes in that white is used for the survey perimeters, black for GPR targets, red for live power and yellow indicating a completed ATS survey location.",
            answer: null
          },
          {
            id: 5,
            questionText: "Do you understand how to prepare an ATS location by indicating and marking the perimeter in white: stencils and ink, tape, paint, permanent marker?       ",
            answer: null
          },
          {
            id: 6,
            questionText: "Are you familiar with the 2” SafeCore standard widths and that they are also available 1.5” and 1” options for marking the targets when highly congested targets are present?",
            answer: null
          },
          {
            id: 7,
            questionText: "Are you familiar with and understand the 6” standard width of the tolerance zone for core drilling and the 24” wide standard tolerance zone for slab on grade cutting?",
            answer: null
          },
          {
            id: 8,
            questionText: "Are you familiar with and understand that optional core drilling tolerance zone widths are available in 3”, 3.5”, 4”, 4.5”, 5” marking paths?",
            answer: null
          },
          {
            id: 9,
            questionText: "Are you familiar with and understand that an optional sawcutting slab-on-grade tolerance zone width is available in an 18” wide marking path?",
            answer: null
          },
          {
            id: 10,
            questionText: "Do you agree that if any optional marking path tolerance zone marking path appears on the survey it was approved by an authorized company representative?",
            answer: null
          },
        ]
      }
    },
    methods: {
      startTest(){
        this.quizOff = false;
      },
      nextQ(index){
        this.currentCard = index + 1;
      },
      notifyVue(message, color) {
        console.log('here2');
        console.log(this.$notify);
        // var color = Math.floor(Math.random() * 4 + 1);
        this.$notify({
          timeout: 3000,
          message: message,
          horizontalAlign: 'left',
          verticalAlign: 'top',
          type: color
        });
      },
      submitTest(){
        var status = {
          status: "passed"
        }
        this.$store.dispatch("submitQuiz", status).then(() => {
          this.$router.push({ path: '/user' });
          this.notifyVue("You have passed the SafeCore Safety and Risk Management Test.", "success");
        });
      }
    }
  }
</script>
<style media="screen">

</style>
